export default __webpack_public_path__ + "static/media/bannerdesktop.f5fa2255.png";